import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Podcast from "@/pages/Podcast";
import ServicePage from "@/components/site/ServicePage";
import { SERVICES } from "@/lib/services";
import { Intro } from "@/components/site/Intro";

function App() {
  const [phase, setPhase] = useState(() =>
    typeof window !== "undefined" && window.sessionStorage.getItem("htc_intro_seen")
      ? "ready"
      : "intro"
  );

  useEffect(() => {
    const locked = phase !== "ready";
    document.documentElement.style.overflow = locked ? "hidden" : "";
    return () => {
      document.documentElement.style.overflow = "";
    };
  }, [phase]);

  const finishIntro = () => {
    try {
      window.sessionStorage.setItem("htc_intro_seen", "1");
    } catch (e) {}
    setPhase("ready");
  };

  return (
    <div className="App grain">
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#171717",
            border: "1px solid #333333",
            color: "#F7F5F0",
            fontFamily: "Montserrat, sans-serif",
            borderRadius: "0",
          },
        }}
      />
      {phase === "intro" && <Intro onDone={finishIntro} />}
      <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/podcast" element={<Podcast />} />
            <Route path="/residential" element={<ServicePage data={SERVICES.residential} />} />
            <Route path="/commercial" element={<ServicePage data={SERVICES.commercial} />} />
            <Route path="/builders" element={<ServicePage data={SERVICES.builders} />} />
            <Route path="/developers" element={<ServicePage data={SERVICES.developers} />} />
            <Route path="/investors" element={<ServicePage data={SERVICES.investors} />} />
          </Routes>
        </BrowserRouter>
      </ReactLenis>
    </div>
  );
}

export default App;
